import { Box } from "@mui/material";
import React from "react";

const GoogleMapEmbed = () => {
    return (
        <Box style={{ width: "100%", height: "400px" }}>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3889.485539813329!2d77.6153673!3d12.876470200000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae6bd9e95a8fbd%3A0xf55c4f12be1cffca!2sMySkool%20Club!5e0!3m2!1sen!2sin!4v1742039706590!5m2!1sen!2sin"
                title="Google Map"
                width="100%"
                height="100%"
                style={{ border: 0,borderRadius:"20px" }}
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
        </Box>
    );
};

export default GoogleMapEmbed;
